module.exports = __webpack_public_path__ + "img/mail.1a8a62e3.svg";